import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_0_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.0.0 Quality control factors
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>
          <section>
            <p className="mt-5">
              Please find important information below from Module 1; this
              information will assist you in Module 2.
            </p>
            <h2 className="h5 b mt-4">Radiation Safety—Drug Handling</h2>
            <p>
              Amyvid is a radioactive drug and should be handled with
              appropriate safety measures to minimize radiation exposure during
              administration. Use waterproof gloves and effective shielding,
              including syringe shields when handling Amyvid.
              Radiopharmaceuticals, including Amyvid, should only be used by or
              under the control of physicians who are qualified by specific
              training and experience in the safe use and handling of
              radioactive materials, and whose experience and training have been
              approved by the appropriate governmental agency authorized to
              license the use of radio pharmaceuticals.
            </p>

            <h2 className="h5 b mt-4">
              Amyvid Dosing and Administration Information
            </h2>
            <p>
              The recommended dose for Amyvid is 370 MBq (10 mCi), maximum 50 µg
              mass dose, administered as a single intravenous bolus in a total
              volume of 10 mL or less; follow the injection with an intravenous
              flush of 0.9% sterile sodium chloride.
            </p>
            <ul className="ms-0">
              <li>
                Inspect the radiopharmaceutical dose solution prior to
                administration and do not use if it contains particulate matter
                or is discolored
              </li>
              <li>
                Use aseptic technique and radiation shielding to withdraw Amyvid
                solution
              </li>
              <li>
                Assay the dose in a suitable dose calibrator prior to
                administration
              </li>
              <li>
                Inject Amyvid through a short intravenous catheter (~1.5 inches
                or less) to minimize the potential for adsorption of the drug to
                the catheter; portions of the Amyvid dose may adhere to longer
                catheters
              </li>
            </ul>

            <h2 className="h5 b mt-4">Image Acquisition Guidelines</h2>
            <p>
              A 10-minute PET image should be acquired starting 30 to 50 minutes
              after Amyvid intravenous injection. The patient should be supine
              with the head positioned to center the brain, including the
              cerebellum, in the PET scanner field of view. Reducing head
              movement with tape or other flexible head restraints may be
              employed. Image reconstruction should include attenuation
              correction with resulting transaxial pixel sizes between 2 and 3
              mm.
            </p>

            <h2 className="h5 b mt-4">Reconstruction and Display</h2>
            <ul className="ms-0">
              <li>
                Image reconstruction should include attenuation correction with
                resulting transaxial pixel sizes between 2 and 3 mm; images
                should be displayed in the transaxial orientation with access as
                needed to the sagittal and coronal planes
              </li>
            </ul>
            <h2 className="h5 b mt-4">Image Interpretation</h2>

            <ul className="ms-0">
              <li>
                Amyvid images should be interpreted only by readers who
                successfully complete Amyvid Reader Training
              </li>
              <li>
                The objective of Amyvid image interpretation is to provide an
                estimate of the brain β-amyloid neuritic plaque density, not
                to make a clinical diagnosis; image interpretation is performed
                independently of a patient’s clinical features
              </li>
            </ul>
            <p>
              The total procedure time, from tracer injection to scan
              completion, is approximately 40 to 60 minutes. Minimal patient
              preparation is required prior to the scan; there are no
              contraindications, and glucose monitoring or fasting is not
              required.
            </p>
          </section>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/isi", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-1-1", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Module_2_0_0;
